import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["id", "onChange"]

import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import Icon from '@/components_new/Icon/Icon.vue'
import ModalContainer from '@/components_new/ModalItems/ModalContainer.vue'
import FennecCoinSilverLargeImage from '@/components_new/ModalItems/images/silver-fennec-coin-large.webp'
import { useTasksStore } from '@/components_new/TaskItems/store'
import Typography from '@/components_new/Typography.vue'
import { useTr } from '@/composables/use-tr'
import { useI18nAddon } from '@/i18n/i18n'
import { useLayoutStore } from '@/store/layout-store'
import { useLoggerStore } from '@/store/logger'
import { useUserStore } from '@/store/user-store/user-store'

import { SurveyData } from './types'
import { getSurveyQuestion } from './utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalSurvey',
  setup(__props) {

const layoutStore = useLayoutStore()
const { isSurveyModalOpened, questionSurveyInfo } = storeToRefs(layoutStore)
const loggerStore = useLoggerStore()
const taskStore = useTasksStore()
const userStore = useUserStore()
const { user } = storeToRefs(userStore)
const { currentLocale } = useI18nAddon()

async function onSubmitModal({ id, text }: { id: string; text: string }) {
    const localeInfo = window.additionalServerData?.locale
    loggerStore.logSurveyEvent({
        gameHru: questionSurveyInfo.value!.hru,
        userId: user.value!._id,
        country: localeInfo?.countryNameEn || 'unknown',
        eventName: 'survey_game_completed',
        locale: currentLocale.value,
        questionId: surveyModalOpenData.value!.questionId,
        selectedOptionText: text,
        selectedOptionId: id,
        questionText: surveyModalOpenData.value!.questionText,
    })
    await taskStore.claimTask(questionSurveyInfo.value!.taskId)
    onCloseModal()
}
const tr = useTr()

const surveyData = computed(() => getSurveyQuestion(tr))
const surveyModalOpenData = computed(() => getDailyQuestion(questionSurveyInfo.value?.questionSeedNum))

function getDailyQuestion(randomSeed: number | undefined): SurveyData | undefined {
    if (randomSeed === undefined) {
        return undefined
    }
    const currentDayNum = new Date().getDay()
    const seedIndex = (currentDayNum + randomSeed) % surveyData.value.length
    return surveyData.value[seedIndex]
}

function onCloseModal() {
    layoutStore.setSurveyModalSurveyInfo(null)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalContainer, {
    image: _unref(FennecCoinSilverLargeImage),
    alt: _ctx.$tr('modalSurvey.alt'),
    isOpened: _unref(isSurveyModalOpened),
    onCloseModal: onCloseModal
  }, _createSlots({ _: 2 }, [
    (surveyModalOpenData.value)
      ? {
          name: "custom-content",
          fn: _withCtx(() => [
            _createElementVNode("fieldset", {
              class: _normalizeClass(_ctx.$style.fieldset)
            }, [
              _createVNode(Typography, {
                is: "legend",
                type: "header",
                size: "s",
                responsive: false,
                class: _normalizeClass(_ctx.$style.legend)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(surveyModalOpenData.value?.question), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(Typography, {
                is: "p",
                class: _normalizeClass(_ctx.$style.description),
                size: "s",
                responsive: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$tr('modalSurvey.description')), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.feedback_list)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surveyModalOpenData.value.options, (option) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: option.selectedOptionId,
                    class: _normalizeClass(_ctx.$style.feedback)
                  }, [
                    _createElementVNode("input", {
                      id: option.selectedOptionId,
                      type: "radio",
                      name: "feedback",
                      class: _normalizeClass(_ctx.$style.hiddenInput),
                      onChange: ($event: any) => (onSubmitModal({ id: option.selectedOptionId, text: option.selectedOptionText }))
                    }, null, 42, _hoisted_1),
                    (option.icon)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 0,
                          name: option.icon,
                          class: _normalizeClass(_ctx.$style[option.icon])
                        }, null, 8, ["name", "class"]))
                      : _createCommentVNode("", true),
                    _createVNode(Typography, {
                      type: "label",
                      size: "l",
                      accent: "",
                      responsive: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option.selectedOption), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ], 2))
                }), 128))
              ], 2)
            ], 2)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["image", "alt", "isOpened"]))
}
}

})